import styled from 'styled-components';
import { px2rem, opacify } from '../utils/helpers/style.js';
import { boxStyles } from '../Box/styles.js';
import { StyledContentText } from '../ContentText/styles.web.js';
import { boxPropExclusions } from '../Box/props.js';
import { styles } from '../constants/styles.js';
import { colors } from '../constants/colors.js';

function getArrowStyle(pos) {
  if (pos && pos.includes('bottom')) {
    return {
      width: '0 1rem 1rem 1rem',
      getColor: function getColor(color) {
        return "transparent transparent ".concat(color, " transparent");
      }
    };
  }
  if (pos && pos.includes('top')) {
    return {
      width: '1rem 1rem 0 1rem',
      getColor: function getColor(color) {
        return "".concat(color, " transparent transparent transparent");
      }
    };
  }
  if (pos && pos.includes('left')) {
    return {
      width: '1rem 0em 1rem 1rem',
      getColor: function getColor(color) {
        return "transparent transparent transparent ".concat(color);
      }
    };
  }
  if (pos && pos.includes('right')) {
    return {
      width: '1rem 1rem 1rem 0',
      getColor: function getColor(color) {
        return "transparent ".concat(color, " transparent transparent");
      }
    };
  }
  return {
    width: '0 1rem 1rem 1rem',
    getColor: function getColor(color) {
      return "transparent transparent ".concat(color, " transparent");
    }
  };
}
var getShadowStyle = function getShadowStyle(popoverShadowStyle) {
  switch (popoverShadowStyle) {
    case 'small':
      return dropShadows.s;
    case 'medium':
      return dropShadows.m;
    case 'none':
      return 'none';
  }
};
var popover = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !boxPropExclusions.has(prop);
  }
}).withConfig({
  displayName: "styles__popover",
  componentId: "sc-1c4n1re-0"
})(["filter:drop-shadow(", ");transition-timing-function:", ";", "{color:", ";}", ";"], function (props) {
  return getShadowStyle(props.$popoverShadowStyle);
}, styles.transition["function"].base, StyledContentText, function (p) {
  return p.textColor;
}, boxStyles);
/*#__PURE__*/styled.div.withConfig({
  displayName: "styles__arrow",
  componentId: "sc-1c4n1re-1"
})(["position:absolute;font-size:", ";bottom:", ";top:", ";left:", ";right:", ";&:before{content:' ';margin:auto;display:block;width:0;height:0;border-style:solid;border-width:", ";border-color:", ";}"], px2rem(9), function (props) {
  return props.$pos && props.$pos.includes('top') ? px2rem(-9) : '';
}, function (props) {
  return props.$pos && props.$pos.includes('bottom') ? px2rem(-9) : '';
}, function (props) {
  return props.$pos && props.$pos.includes('right') ? px2rem(-9) : '';
}, function (props) {
  return props.$pos && props.$pos.includes('left') ? px2rem(-9) : '';
}, function (props) {
  return getArrowStyle(props.$pos).width;
}, function (props) {
  return getArrowStyle(props.$pos).getColor(props.$backgroundColor);
});
var dropShadows = {
  /**
   * The small popover shadow, intended to be used with CSS filter drop-shadow
   */
  s: "0 0 ".concat(px2rem(8), " ").concat(opacify(colors.fullBlack, 0.2)),
  /**
   * The base popover shadow, intended to be used with CSS filter drop-shadow
   */
  m: "0 0 ".concat(px2rem(27), " ").concat(opacify(colors.fullBlack, 0.1))
};

export { dropShadows, getArrowStyle, popover };
